exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-range.comment{font-style:italic}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/autoprefixer-loader!./src/blocks/comment-block.scss
 ** module id = 382
 ** module chunks = 0
 **/